export default __webpack_public_path__ + "static/media/model2.f18f7fad.png";